import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getBlogPage = createAsyncThunk('blogPage/getBlogPage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getBlogsPage();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
